export const QUALITATIVE_AI_ACCENT = '#6fa84f';

export const getQualitativeOccupancy = (article) => (
  article?.editorialOccupancy || article?.onlineCentimetragem || {}
);

export const isQualitativeAnalysisAiApplied = (article) => {
  const occupancy = getQualitativeOccupancy(article);
  return Boolean(occupancy?.aiUsed);
};
